import { IdpType } from '@shared/enums/IdpType';

export enum ActivityTimeRange {
  LastHour = 0,
  Last4Hour = 1,
  Last12Hour = 2,
  Last24Hour = 3,
  Last48Hour = 4,
  LastWeek = 5,
  Last2Weeks = 6,
  LastMonth = 7,
  Last3Month = 8,
}

export enum Application {
  DashboardUI,
  MobileUI,
  Connector,
  FrontDesk,
  FrontDeskMobile,
  PublicPage,
  Scheduler,
  AadProvisioningService,
  PublicApi
}

export class ShowBadgeVm {
  showBatch: boolean;
  batchCount: number;
  showRegistration: boolean;
  showCrm: boolean;
  showMobile: boolean;
  showAddressBook: boolean;
  showInvitation: boolean;
  showByInvitee: boolean;
  showByUser: boolean;
  showNewContact: boolean;
  showExtraGuest: boolean;
  showExtraGuests: boolean;
  extraGuestCount: number;
  showFrontDesk: boolean;
  showIsCloned: boolean;
  showTime: boolean;
  showAad: boolean;
  showFieldDrive: boolean;
  okCount: number;
  showOk: boolean;
  failCount: number;
  showFail: boolean;
  ongoingCount: number;
  showOngoing: boolean;
  showIsManaged: boolean;
  showOkta: boolean;
}


export enum ActivityType {
  InvitationConfirmedContactActivity = 'InvitationConfirmedContactActivity',
  InvitationConfirmedActivity = 'InvitationConfirmedActivity',
  InvitationDeclinedContactActivity = 'InvitationDeclinedContactActivity',
  InvitationDeclinedActivity = 'InvitationDeclinedActivity',
  InvitationCreatedActivity = 'InvitationCreatedActivity',
  InvitationDeletedActivity = 'InvitationDeletedActivity',
  InvitationCancelledContactActivity = 'InvitationCancelledContactActivity',
  InvitationCancelledActivity = 'InvitationCancelledActivity',
  ContactAnonimizedActivity = 'ContactAnonimizedActivity',
  ContactAnonimizedBatchActivity = 'ContactAnonimizedBatchActivity',
  ContactCreatedActivity = 'ContactCreatedActivity',
  ContactCreatedConnectorActivity = 'ContactCreatedConnectorActivity',
  ContactDisabledActivity = 'ContactDisabledActivity',
  ContactDisabledBatchActivity = 'ContactDisabledBatchActivity',
  ContactEnabledActivity = 'ContactEnabledActivity',
  ContactEnabledBatchActivity = 'ContactEnabledBatchActivity',
  ContactUpdatedActivity = 'ContactUpdatedActivity',
  ContactUpdatedConnectorActivity = 'ContactUpdatedConnectorActivity',
  ContactUpdatedContactActivity = 'ContactUpdatedContactActivity',
  UserResentActivity = 'UserResentActivity',
  LoginActivity = 'LoginActivity',
  LogoutActivity = 'LogoutActivity',
  EventClonedActivity = 'EventClonedActivity',
  EventStoppedActivity = 'EventStoppedActivity',
  EventStartedActivity = 'EventStartedActivity',
  EventPublishedActivity = 'EventPublishedActivity',
  MailSendActivity = 'MailSendActivity',
  MailSendSchedulerActivity = 'MailSendSchedulerActivity',
  InvitationExpiredBatchSchedulerActivity = 'InvitationExpiredBatchSchedulerActivity',
  SupportAllowedActivity = 'SupportAllowedActivity',
  SupportDeniedActivity = 'SupportDeniedActivity',
  AttendeeUndoCheckedInActivity = 'AttendeeUndoCheckedInActivity',
  AttendeeUndoCheckedInBatchActivity = 'AttendeeUndoCheckedInBatchActivity',
  AttendeeTicketCheckedOutActivity = 'AttendeeTicketCheckedOutActivity',
  ExportEventSurveyStatisticsActivity = 'ExportEventSurveyStatisticsActivity',
  InvitationConfirmedFrontDeskActivity = 'InvitationConfirmedFrontDeskActivity',
  InvitationSyncCrmBatchActivity = 'InvitationSyncCrmBatchActivity',
  FooterClonedActivity = 'FooterClonedActivity',
  UserRoleAttachedAadActivity = 'UserRoleAttachedAadActivity',
  UserRoleDetachedAadActivity = 'UserRoleDetachedAadActivity',
  InvitationImportedInBatchConnectorActivity = 'InvitationImportedInBatchConnectorActivity',
}

export interface IActivityLogBase {
  type: ActivityType;
  application: Application;
  contactEmail: string;
  contactName: string;
  occurredOn: Date;
  userName: string;
  userEmail: string;
  batchLabel: string;
  batchCount: number;
  crm: string;
  displayable: any;
  size: number;
}

